import { Divider } from "@heroui/react";
import { Settings } from "lucide-react";

import { usePanel } from "@/contexts/PanelContext";

import { OverlaySettings } from "../Overlay/OverlaySettings";
import { SidebarBase } from "../SidebarBase";
import { AudioSettings } from "./AudioSettings";
import { ChatSettings } from "./ChatSettings";
import { MiscSettings } from "./MiscSettings";
import { TemplateSettings } from "./TemplateSettings";

export const SettingsSidebar = () => {
  const Panel = usePanel();

  return (
    <SidebarBase
      shown={Boolean(Panel.state.settings)}
      setSidebarShown={(state) => Panel.dispatch(["settings", state])}
      icon={Settings}
      title="Settings"
      description="Configuration options for customizing your experience"
      side="Right"
      width="25rem"
    >
      <div className="p-4 flex flex-col gap-4">
        <TemplateSettings />
        <Divider />
        {__DEV_CHAT__ && (
          <>
            <ChatSettings />
            <Divider />
          </>
        )}
        <OverlaySettings />
        <Divider />
        <AudioSettings />
        <Divider />
        <MiscSettings />
      </div>
    </SidebarBase>
  );
};
